<template>
    <div class="rich-text rich-text__plain">
        <p class="rich-text--text" v-text="content.text"></p>
    </div>
</template>

<script>
    import cmsPlugin from 'vue/mixins/cms/cms-plugin';


    export default {
        mixins: [
            cmsPlugin,
        ],
    };
</script>



// WEBPACK FOOTER //
// index.vue?1970fb07